Filters on relationship types between the hirer and requesting partner.

See the `HiringOrganizationApiCapabilities.relationshipTypeCodes` documentation for a list of relationship types.

If this is not provided then all related hirers are returned.
